"use strict";

const { includes } = require("lodash");

let loginForm = $('#login_form');

$(document).ready(function(){
    // Default initialization
    $(".styled").uniform();

    // File input
    $(".file-styled").uniform({
        wrapperClass: 'bg-blue',
        fileButtonHtml: '<i class="icon-file-plus"></i>'
    });

    $('.selectpicker').selectpicker();
});

$('#login').click(function (e) {
    e.preventDefault();
    if(loginForm.valid()) {
        Ajax.post('/login', loginForm.serialize())
            .then(function(response) {
                location.replace('/home');
            })
            .catch(function(error) {
                console.log(error);
                if(error.response.status && error.response.status===422) {
                    // if (error.response.data.errors.hasOwnProperty('company')) {
                    //     $('.genericModal123').modal('show');
                    //   }
                    window.notifier.alert(error.response.data.errors.email[0]);
                }
            });
    }

});
